<template>
  <div class="form-group">
    <ed-input-tooltip v-if="(helptipBody || errorTipBody) && focused"
                      :class='{ "error-message": error }'
                      :helptipHeader='error ? errorTipHeader : helptipHeader'
                      :errorTip='error'
                      :helptipBody='error ? errorTipBody : helptipBody' />
    <label class="control-label" v-if="fieldLabel">
      {{fieldLabel}}
      <em class="optional" v-if="!required && !hideOptional"> &nbsp;- optional</em>
    </label>
    <textarea class="form-control"
              :autofocus="autofocus"
              :required="required"
              :value="value"
              v-bind="$props"
              v-focus.lazy="autofocus"
              @focus="focused = true"
              @blur="focused = false"
              @input="value = $event.target.value;$emit('input', $event.target.value)"
              @change="value = $event.target.value;$emit('change', $event.target.value)"
              ref="input">
    </textarea>
    <span v-if="maxLength > 0">
      <span class="textarea-chars"><i>{{remainingChars}}</i></span>
      <span class="clear"></span>
    </span>
  </div>
</template>

<script>

  import EdInputTooltip from '@/core/components/edInputTooltip/index.vue'

  export default {
    name: 'ed-textarea',
    props: {
      type: {
        type: String,
        default: 'text'
      },
      fieldLabel: String,
      hideOptional: Boolean,
      name: String,
      disabled: Boolean,
      error: Boolean,
      placeholder: String,
      value: [String, Number],
      required: {
        type: Boolean,
        default: false
      },
      autofocus: {
        type: Boolean,
        default: false
      },
      rows: Number,
      cols: Number,
      maxLength: Number,
      helptipHeader: String,
      helptipBody: String,
      errorTipHeader: String,
      errorTipBody: String
    },
    directives: {
      focus: {
        inserted: function (el, binding) {
          if (binding.value) el.focus()
          else el.blur()
        },
        componentUpdated: function (el, binding) {
          if (binding.modifiers.lazy) {
            if (Boolean(binding.value) === Boolean(binding.oldValue)) {
              return
            }
          }
          if (binding.value) el.focus()
          else el.blur()
        }
      }
    },
    components: {
      'ed-input-tooltip': EdInputTooltip
    },
    data: function () {
      return {
        focused: false
      }
    },
    computed: {
      remainingChars() {
        if (!this.maxLength || isNaN(this.maxLength)) return ''
        let chars = this.value && this.value.length
        let remaining = this.maxLength - chars
        if (remaining < 0) remaining = 0
        return remaining + ' characters remaining'
      }
    }
  }
</script>

<style scoped lang='scss'>
  @import "~@/assets/sass/_variables.scss";
  @import "~@/assets/sass/_form_fields.scss";

  .form-group {
    em.optional {
      @include optional-label;
    }
  }

  .form-control,
  .form-group .form-control {
    @include form-field;
    resize: none;
    height: auto;
  }

  .editor.form-group textarea {
    &, &:hover
    {
      @include theme {
        color: v(background);
        background: v(ink);
      }
    }
  }
  
  .textarea-chars {
    font-size:12px;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/core/components/edTextarea/index.vue